import { createFileRoute } from '@tanstack/react-router';

import { ExplorerLayout } from '~/features/explorer/components/explorer-layout';

/**
 * Explorer layout route. Renders the subsidiary-scoped shell (page header +
 * subsidiary picker + tab bar + `<Outlet/>`) so every browsing page (Products,
 * Keyword Planner, Catalog Quality Score, Coverage Report, Data Lake, Analytics
 * Data) shares one chrome. No guard here — child routes add their own
 * (`requireSystemAdmin`), matching the Integrations layout.
 */
export const Route = createFileRoute('/_authenticated/_tenant/explorer')({
  component: ExplorerLayout,
});
